// src/components/CurrentTripDigestDialog.jsx
// UPGRADED: Now uses RichTextEditor for the journal entry.

import React, { useEffect, useState } from 'react';
// --- NEW: Import the RichTextEditor ---
import RichTextEditor from './AlbumPageTemplates/RichTextEditor';

// --- NEW: Inject styles for the editor's dark mode theme ---
// (These are from AlbumFromPast.jsx to ensure it renders correctly here)
const styles = `
  .rich-text-editor-wrapper-dark {
    border-radius: 8px;
    overflow: hidden;
  }
  
  .rich-text-editor-wrapper-dark [contentEditable] {
    background: #334155 !important;
    color: #e2e8f0 !important;
    border: 1px solid #475569 !important;
    min-height: 120px !important;
  }
  
  .rich-text-editor-wrapper-dark button {
    background: #475569 !important;
    color: #e2e8f0 !important;
  }
  
  .rich-text-editor-wrapper-dark button:hover {
    background: #64748b !important;
  }
`;

if (typeof document !== 'undefined') {
  const styleId = 'rte-dark-theme-styles';
  if (!document.getElementById(styleId)) {
    const styleSheet = document.createElement("style");
    styleSheet.id = styleId;
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }
}
// --- End of new styles ---


export default function CurrentTripDigestDialog({ open, onClose, onConfirm }) {
  // Last-7-days selection (multi-select)
  const [selectedDates, setSelectedDates] = useState(() => {
  const today = new Date().toISOString().slice(0, 10);
  return [today];      // Default: only TODAY selected
});


  const [addJournal, setAddJournal] = useState(true);
  const [journalText, setJournalText] = useState('');
  const [tripTitle, setTripTitle] = useState('Current Trip');


  useEffect(() => {
  if (!open) {
    const todayISO = new Date().toISOString().slice(0, 10);
setSelectedDates([todayISO]);

    setAddJournal(true);
    setJournalText('');
    setTripTitle('Current Trip');
  }
}, [open]);


  if (!open) return null;

  const handleSubmit = (e) => {
  e.preventDefault();

  const dates = Array.isArray(selectedDates)
    ? selectedDates.filter(Boolean).sort()
    : [];

  if (!dates.length) {
    alert('Please select at least one day for your Daily Digest.');
    return;
  }

  onConfirm({
    selectedDates: dates,
    journalText: addJournal ? journalText : '',
    tripTitle: tripTitle || 'Current Trip',
  });
};


  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div 
        className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm" 
        onClick={onClose} 
      />
      
      <div className="relative w-full sm:max-w-lg bg-slate-900 text-slate-100 rounded-2xl shadow-xl border border-slate-700">
        <form onSubmit={handleSubmit}>
          {/* Header */}
          <div className="px-6 pt-5 pb-4 border-b border-slate-700">
            <div className="flex items-start justify-between">
              <div>
                <h2 className="text-xl font-semibold">Current Trip – Daily Digest</h2>
                <p className="text-sm text-slate-400 mt-1">
                  Customize your album and optionally add a journal note.
                </p>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="text-slate-400 hover:text-slate-200 text-2xl leading-none px-2"
              >
                &times;
              </button>
            </div>
          </div>

          {/* Body */}
          <div className="px-6 py-5 space-y-6">
            
            {/* Trip Title Field */}
            <div>
              <label 
                htmlFor="tripTitle" 
                className="block text-sm font-medium text-slate-300 mb-2"
              >
                Trip Title
              </label>
              <input
                type="text"
                id="tripTitle"
                value={tripTitle}
                onChange={(e) => setTripTitle(e.target.value)}
                placeholder="e.g., Summer in Spain"
                className="w-full mt-1 rounded-lg border border-slate-700 bg-slate-800 px-3 py-2 text-base resize-none focus:outline-none focus:ring-1 focus:ring-emerald-400"
              />
              <p className="text-xs text-slate-500 mt-1.5">
                This will appear on your album's cover page.
              </p>
            </div>

            {/* Days slider */}
            {/* Day selection (past 7 days) */}
<div>
  <div className="flex justify-between items-center mb-2">
    <span className="text-sm font-medium">Days to include</span>
    <span className="text-xs text-slate-400">
      Choose one or more days from the past week
    </span>
  </div>

  {(() => {
    const today = new Date();
    const daySlots = [];

    for (let offset = 0; offset < 7; offset++) {
      const d = new Date(today);
      d.setDate(today.getDate() - offset);
      const iso = d.toISOString().slice(0, 10);

      let labelMain;
      if (offset === 0) labelMain = 'Today';
      else if (offset === 1) labelMain = 'Yesterday';
      else labelMain = d.toLocaleDateString(undefined, { weekday: 'short' });

      const labelSub = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      daySlots.push({ iso, labelMain, labelSub });
    }

    const toggleDate = (iso) => {
      setSelectedDates((prev) => {
        if (!Array.isArray(prev)) prev = [];
        const exists = prev.includes(iso);

        // Do not allow clearing the last selected day
        if (exists && prev.length === 1) return prev;

        if (exists) {
          return prev.filter((d) => d !== iso);
        }
        return [...prev, iso];
      });
    };

    // Show oldest → newest (optional, feel free to reverse if you prefer)
    const ordered = daySlots.slice().reverse();

    return (
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {ordered.map((slot) => {
          const isSelected =
            Array.isArray(selectedDates) && selectedDates.includes(slot.iso);

          const base =
            'px-2 py-1.5 rounded-lg border text-xs flex flex-col items-center justify-center transition-colors';
          const onClasses =
            'bg-emerald-500 text-slate-900 border-emerald-400';
          const offClasses =
            'bg-slate-800 text-slate-200 border-slate-600 hover:bg-slate-700';

          return (
            <button
              key={slot.iso}
              type="button"
              onClick={() => toggleDate(slot.iso)}
              className={`${base} ${isSelected ? onClasses : offClasses}`}
            >
              <span className="font-semibold">{slot.labelMain}</span>
              <span className="text-[11px] text-slate-300">
                {slot.labelSub}
              </span>
            </button>
          );
        })}
      </div>
    );
  })()}
</div>


            {/* Journal toggle + RichTextEditor */}
            <div className="space-y-3">
              <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
                <input
                  type="checkbox"
                  className="h-4 w-4 accent-emerald-400"
                  checked={addJournal}
                  onChange={(e) => setAddJournal(e.target.checked)}
                />
                <span>Add a journal page</span>
              </label>

              {addJournal && (
                // --- THIS IS THE REPLACEMENT ---
                <div className="rich-text-editor-wrapper-dark">
                  <RichTextEditor
                    value={journalText}
                    onChange={setJournalText} // The editor's onChange passes the new HTML string
                    placeholder="What do you want to say about these days? (Up to ~300–400 words works best.)"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Footer buttons */}
          <div className="px-6 pb-5 pt-4 border-t border-slate-700 flex gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg text-sm font-medium bg-slate-800 hover:bg-slate-700 text-slate-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-lg text-sm font-semibold bg-emerald-500 hover:bg-emerald-400 text-slate-900"
            >
              Generate Daily Digest
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}